import { QueryClient } from '@tanstack/react-query'

/**
 * Shared QueryClient instance for React Query.
 * This is used by both the AppProvider and utility functions that need to
 * invalidate queries outside of React components (e.g., in Apollo error handlers).
 */
export const queryClient = new QueryClient()
